<template>
  <div style="margin-bottom: 20px;">
    <h2>A/B Group Watchers</h2>

    <div class="row mt-4">
      <div class="col-sm-4">
        <h3>Tags</h3>

        <search-select
          :multiple="true"
          v-model="watchers"
          :options="$store.state.abFieldsWatcher"
          :taggable="true"
          :label="'label'"
          @input="setTagWatcher"
        />

      </div>

      <div class="col-sm-4">
        <div style="text-align: center">
          <h3>Value</h3>

          <span style="margin-right: 20px;">
            <label for="onValueAB"><input id="onValueAB" @click="valueOnAb = true" :checked="valueOnAb" type="radio" name="valueAbTag"> Yes</label>
          </span>

          <span>
            <label for="offValueAB"><input id="offValueAB" @click="valueOnAb = false" :checked="!valueOnAb" type="radio" name="valueAbTag"> No</label>
          </span>
        </div>
      </div>

      <div class="col-sm-4">
        <h3>Visible</h3>

        <input @click="setVisibility" :checked="valueVisibleAb" type="checkbox">
      </div>
    </div>
  </div>
</template>

<script>
import SearchSelect from '../searchSelect/SearchSelect.vue'

export default {
  name: 'ab-group-watchers',

  data () {
    return {
      valueVisibleAb: true,
      valueOnAb: true,
      watchers: []
    }
  },

  props: {
    isGroup: {
      type: Boolean,
      default: false
    },

    fieldData: {
      type: Object
    }
  },

  components: {
    SearchSelect
  },

  created () {
    this.watchers = this.fieldData.watchers
    this.valueVisibleAb = this.fieldData.tagVisible !== undefined ? this.fieldData.tagVisible : true
  },

  methods: {
    setVisibility () {
      this.valueVisibleAb = !this.valueVisibleAb

      if (this.isGroup === true) {
        this.$store.commit('editFieldGroup', {
          index: this.fieldData.index,
          tagVisible: this.valueVisibleAb
        })
      } else {
        this.fieldData.tagVisible = this.valueVisibleAb

        this.$store.commit('setTemplateFieldPage', this.fieldData)

        let questionnaires = JSON.parse(JSON.stringify(this.$store.state.questionnaires))

        Object.keys(questionnaires[this.$store.state.currentTemplateName].data).forEach(fieldKey => {
          let fieldId = this.fieldData.fieldName !== undefined ? this.fieldData.fieldName : this.fieldData.id

          if (questionnaires[this.$store.state.currentTemplateName].data[fieldKey].fieldName === fieldId) {
            questionnaires[this.$store.state.currentTemplateName].data[fieldKey].tagVisible = this.valueVisibleAb
          }

          // Assign tags to field group fields

          if (
            questionnaires[this.$store.state.currentTemplateName].data[fieldKey].checkboxes !== undefined &&
            Object.keys(questionnaires[this.$store.state.currentTemplateName].data[fieldKey].checkboxes).length > 0
          ) {
            let checkboxes = questionnaires[this.$store.state.currentTemplateName].data[fieldKey].checkboxes

            Object.keys(checkboxes).forEach(fieldChKey => {
              let fieldId = this.fieldData.fieldName !== undefined ? this.fieldData.fieldName : this.fieldData.id

              if (checkboxes[fieldChKey].id === fieldId) {
                checkboxes[fieldChKey].tagVisible = this.valueVisibleAb
              }
            })
          }
        })

        this.$store.commit('setQuestionnaires', questionnaires)
      }

      this.$bus.emit('updateQuestionnaire')
      this.$store.dispatch('saveTemplate')
    },

    setTagWatcher (watchers) {
      if (watchers.length > 0) {
        // watchers[(watchers.length - 1)].value = this.valueOnAb
        watchers[(watchers.length - 1)] = {label: watchers[(watchers.length - 1)], value: this.valueOnAb, visible: this.valueVisibleAb}
        // watchers[(watchers.length - 1)].visible = this.valueVisibleAb
      }

      this.watchers = watchers

      this.fieldData.watchers = watchers

      if (this.isGroup === true) this.setWatcherToGroup(watchers)
      else this.setWatcherToField(watchers)
    },

    setWatcherToField (watchers) {
      this.$store.commit('setTemplateFieldPage', this.fieldData)

      let tmpQuestionnaires = JSON.parse(JSON.stringify(this.$store.state.questionnaires))

      if (this.fieldData.fieldName !== undefined) this.fieldData.id = this.fieldData.fieldName

      Object.keys(tmpQuestionnaires.default.data).forEach(fieldKey => {
        if (tmpQuestionnaires.default.data[fieldKey] === null || tmpQuestionnaires.default.data[fieldKey] === undefined) return

        if (tmpQuestionnaires.default.data[fieldKey].fieldName === this.fieldData.id) {
          tmpQuestionnaires.default.data[fieldKey].watchers = watchers

          this.$store.commit('setQuestionnaires', tmpQuestionnaires)

          this.$store.dispatch('saveTemplate')
          this.$bus.emit('reloadQuestionnaire')
        }
      })
    },

    setWatcherToGroup (watchers) {
      this.$store.commit('editFieldGroup', this.fieldData)

      this.$store.dispatch('saveTemplate')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/questionnaires/ABGroupWatchers.vue